import React from 'react'
import { connect } from 'react-redux'
import {withTranslation} from "react-i18next";
import { BrowserRouter } from "react-router-dom";

import SideBar from 'components/common/SideBar';
import Content from 'components/common/Content';
import * as types from 'reducer/actionTypes';

class Main extends React.Component {
	componentDidMount(){
		this.props.fetchLanguage()
	}

	render(){
		const {t} = this.props;

		return (
			<div className="wrap">
				<div className="header">
                    <h1 className={t('lang')}><span></span></h1>
					<div className="btn_logout" title={t('cm.link.label.logout')} onClick={this.props.fetchLogout}></div>
				</div>
				<div className="content">
					<BrowserRouter basename={this.props.basename}>
						<SideBar submenus={this.props.submenus}/>
						<Content submenus={this.props.submenus}/>
					</BrowserRouter>
				</div>
			</div>
		);
	}
}

// state를 해당 컴포넌트의 props로 연결
const mapStateToProps = (reducers) => {
	return{
		basename: reducers.main.basename,
		submenus: reducers.main.submenus
	}
}

// 컴포넌트의 함수형 poprs를 실행했을때, 지정한 action을 dispatch 하도록 설정
const mapDispatchToProps = (dispatch) => {
	return{
		fetchLogout: () => {dispatch({type: types.FETCH_LOGOUT_REQUEST})},
		fetchLanguage: () => {dispatch({type: types.FETCH_I18N_LANGUAGE_REQUEST})} //fetchSetting.js
	}
}

export default withTranslation()(connect(mapStateToProps,mapDispatchToProps)(Main))
